import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import AuthService from '../utilities/services/auth.service'
import { logReportAccess } from '../utilities/api'
import { resolveTrackedReport } from '../utilities/reportRoutes'

export default function useReportAccessTracking() {
  const location = useLocation()
  const lastLoggedRef = useRef(null)

  useEffect(() => {
    if (!AuthService.isLoggedIn()) return

    const report = resolveTrackedReport(location.pathname)
    if (!report) return

    const org = AuthService.getOrg()?.[0]
    if (!org?.uuid) return

    const logKey = `${org.uuid}:${report.id}:${location.pathname}`
    if (lastLoggedRef.current === logKey) return
    lastLoggedRef.current = logKey

    logReportAccess({
      organizationUUID: org.uuid,
      reportId: report.id,
      reportTitle: report.title,
      reportPath: location.pathname,
    }).catch(() => {
      // Access logging should never block report navigation.
    })
  }, [location.pathname])
}
